import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CustomIconButton, Tooltip } from "../../../components";
import { DeleteForever, Edit } from "../../../icons";
import { useHistory } from "react-router-dom";
// todo: disable delete on permission

function KeywordListActions({ onDelete, keyword, canDelete }) {
  const { t } = useTranslation();
  const history = useHistory();
  const _onDelete = useCallback(() => onDelete(keyword), [onDelete, keyword]);

  const linkToUpdate = () => {
    history.push({
      pathname: "/keyword/update",
      state: { keyword: keyword },
    });
  };

  return (
    <>
      <Tooltip title={t("Edit keyword")}>
        <CustomIconButton
          size="small"
          color="primary"
          onClick={linkToUpdate}
          data-test-id={`edit-button-${keyword.shortcode}-${keyword.keyword}-${keyword.value}`}
        >
          <Edit fontSize="small" />
        </CustomIconButton>
      </Tooltip>
      <Tooltip title={t("Delete keyword")}>
        <CustomIconButton
          size="small"
          color="error"
          onClick={_onDelete}
          disabled={!canDelete}
          data-test-id={`delete-button-${keyword.shortcode}-${keyword.keyword}-${keyword.value}`}
        >
          <DeleteForever fontSize="small" />
        </CustomIconButton>
      </Tooltip>
    </>
  );
}

export default memo(KeywordListActions);
